import React from "react";

import Cotizacion3 from "../../components/CotizacionFinanciero/CotizacionFinanciero3";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { fetchConsultarCarritoFinanciero,fetchListarLimitesFinanciero} from "../../redux/actions/aRamoLineaFinanciera";
import {encriptarTramaAES} from "../../utils/Encriptar/index";
import logo from "assets/img/logo/logo_aig_login-2.png";
import LoadingScreen from "react-loading-screen";

class ContainerCotizacionFinanciero3 extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      listarPreguntas: [],
      valPreguntas : false,
      valAlerta: false,
      valLoading: false,
    };
    this.handleBack = this.handleBack.bind(this);
  }

  async componentDidMount() {
    const queryParams = new URLSearchParams(this.props.location.search);
    if(queryParams.get('id') !== null){
      /*Consulta Carrito*/  
        const datosJSON = {
            idCarrito: queryParams.get('id')
          }
      const encriptado = encriptarTramaAES(JSON.stringify(datosJSON));
      await this.props.consultarCarrito(Buffer.from(JSON.stringify(encriptado)).toString('base64'));   
    }

    console.log(queryParams.get('preservar') === null || queryParams.get('preservar')==="no", typeof(queryParams.get('preservar')) )
    /*Consulta Limites*/
    await this.props.listarLimites(this.props.detalleCarrito.datosCarritoFinanciero.carSeguro,this.props.detalleCarrito.datosCarritoFinanciero.ingresos.ingCodigoCore);

    this.setState({valLoading:true})
  }

  /**
   * Regresar al anterior paso
   */
  async handleBack() {
      // actualizar los datos, para que se precarguen correctamente en el paso anterior
      const datosJSON = {
        idCarrito: this.props.respuestaCarrito.respuestaGuardarFinanciero.idCarrito,
      }
      // encriptar body y enviar al servicio
      const encriptado = encriptarTramaAES(JSON.stringify(datosJSON))
      await this.props.consultarCarrito(Buffer.from(JSON.stringify(encriptado)).toString('base64'))
      // actualizar el ultimo paso en el servicio
      // const datosJSON2 = {
      //   paso:`${paso}`,
      //   preguntas: {idCarrito: this.props.respuestaCarrito.respuestaGuardarFinanciero.idCarrito}
      // }
      // const encriptado2 = await encriptarTramaAES(JSON.stringify(datosJSON2));
      // await this.props.guardarCarrito({"Data": Buffer.from(JSON.stringify(encriptado2)).toString('base64')});
      if(/* this.props.respuestaCarrito.respuestaGuardarFinanciero.errorDescripcion===undefined */ 
          !this.props.detalleCarrito.consultarCarritoFinancierohasError){
          /*Pasa a la siguiente pantalla*/      
          this.props.history.push({
            pathname: '/estatus-cotizacion-financiero',
            search: `?${
              new URLSearchParams({
                preservar:'si'
              }).toString()
            }`
          });
      }
  }


  render() {
    const {detalleCarrito, limitesFinanciero}= this.props;

    console.log('help: ', limitesFinanciero)

    return (
      <main className="bg-light">
        <div className="cr-content container-fluid">
          <div className="container-body-spaces">
          <LoadingScreen
              loading={detalleCarrito.consultarCarritoFinancieroIsLoading || limitesFinanciero.listarLimitesFinancieroIsLoading}
              bgColor="#f1f1f1"
              spinnerColor="#001871"
              textColor="#676767"
              logoSrc={logo}
              text="Cargando datos..."
            >{
              limitesFinanciero.listarLimites.transaccion && this.state.valLoading &&  <Cotizacion3
              detalleCarrito={detalleCarrito.datosCarritoFinanciero}
              limitesFinanciero={limitesFinanciero}
              handleBack={this.handleBack}
              preservar={new URLSearchParams(this.props.location.search).get('preservar')}
            />
            }
             
            </LoadingScreen>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = state => ({
  limitesFinanciero :state.datosListarLimitesFinanciero,
  detalleCarrito : state.datosCarritoFinanciero,
  respuestaCarrito : state.datosCotizacionFinanciero
});

const mapDispatchToProps = dispatch => {
  return {
    consultarCarrito: (data) => dispatch(fetchConsultarCarritoFinanciero(data)),
    listarLimites: (codProducto,codIngreso) => dispatch(fetchListarLimitesFinanciero(codProducto,codIngreso))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ContainerCotizacionFinanciero3)
);
